import { ButtonTriggerEvent } from "common/components";
import { Account } from "../../../../../../models/admin/account";
import { HubGooglePlaceBasicData } from "../../../../../../models/hub/hub.google.place.data";

export class SearchGooglePlaceResultModalActions {
    confirm: (event: ButtonTriggerEvent, image: any) => void;
    cancel?: () => void;
}

export class SearchGooglePlaceResultModalData {
    constructor(places, hubName, blockedCategories, allowedCategories) {
        this.places = places;
        this.hubName = hubName;
        this.blockedCategories = blockedCategories;
        this.allowedCategories = allowedCategories;
    }
    places: HubGooglePlaceBasicData[];
    hubName: string;
    blockedCategories: string;
    allowedCategories: string[];    
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/search.google.place/search.google.place.result.modal/search.google.place.result.modal.provider.ts